/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Form_OverloadInputs */

const en_coach_form_overload = /** @type {(inputs: Coach_Form_OverloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep Fatigue. High Risk. Rest recommended.`)
};

const de_coach_form_overload = /** @type {(inputs: Coach_Form_OverloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiefe Ermüdung. Hohes Risiko. Gönn dir Ruhe.`)
};

/**
* | output |
* | --- |
* | "Deep Fatigue. High Risk. Rest recommended." |
*
* @param {Coach_Form_OverloadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_form_overload = /** @type {((inputs?: Coach_Form_OverloadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Form_OverloadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_form_overload(inputs)
	return de_coach_form_overload(inputs)
});